export default "__VITE_ASSET__Ddg7Wx3M__"